import { render } from "./CreateWallet.vue?vue&type=template&id=33495a83"
import script from "./CreateWallet.vue?vue&type=script&lang=ts"
export * from "./CreateWallet.vue?vue&type=script&lang=ts"

import "./CreateWallet.vue?vue&type=style&index=0&id=33495a83&lang=scss"
script.render = render

export default script